import { Component, HostListener, ViewChild, ViewChildren, ElementRef, QueryList } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { PagerService } from '@app/services/pager.service';
import { CommonService } from '@app/services/common.service';
import { Helper } from '../../../../../4services/2helper'
import { c_components } from 'src/3ui/2components';
import ims from '../../../imports'
import { BaseComponent } from '@app/directives/base-component'

interface MpSessionsManagerFilterState {
  stime: number | null;
  etime: number | null;
  selectedDealer: {
    dealer_id: number;
    name: string;
  } | null;
  selectedSite: {
    site_id: number;
    name: string;
  } | null;
  selectedUser: {
    user_id: number;
    name: string;
    email?: string;
    ip?: string;
  } | null;
  selectedCode: {
    code_id: number;
    code_name: string;
  } | null;
}

// Different storage key to avoid conflicts with customer-session
const MP_SESSIONS_MANAGER_FILTERS_KEY = 'chekt::mp-sessions-manager-filters';

@Component({
    selector: 'c_dtable_mp_sessions_manager',
    templateUrl: './c_dtable_mp_sessions_manager.component.html',
    styleUrls: ['../../common.scss', './c_dtable_mp_sessions_manager.component.scss'],
    standalone: false
})
export class c_dtable_mp_sessions_manager_component extends BaseComponent {
  @ViewChild('siteSelect') siteSelect: ElementRef;
  @ViewChild('dealerSelect') dealerSelect: ElementRef;
  @ViewChild('userSelect') userSelect: ElementRef;
  @ViewChild('codeSelect') codeSelect: ElementRef;
  @ViewChildren('actionMenus') actionMenus: QueryList<any>
  @ViewChildren('columnFilterbox', {read: ElementRef}) columnFilterbox: QueryList<any>
//-----------------------------------------------------------------------------
  isLoading = false;
  tableHeader = [
    { name: 'Event ID', value: 'event_id', width: "8%" },
    { name: 'Site Name', value: 'site_name', width: "20%" },
    { name: 'Dealer Name', value: 'dealer_name', width: "15%" },
    { name: 'Operator', value: 'user_name', width: "8%" },
    { name: 'Start Time', value: 'start_time', width: "8%" },
    { name: 'Duration', value: 'duration_time', width: "12%" },
    { name: 'Resolution Category', value: 'code', width: "12%" },
    { name: 'Response', value: null, width: "12%" },
    { name: '  ', value: null, width: "5%" },
  ]

  // permission
  hasReadSessionPermission = false;
  hasReadSessionCodePermission = false;
  hasCreatePublishedReportPermission = false;

  // list
  filteredSessionList = [];
  originalSessionList = [];
  pagedItems = [];

  isFocusSearch = false;
  searchText = '';

  // date range
  stime = null;
  etime = null;
  currentStime = null;
  currentEtime = null;

  // filter - dealer
  isUnfoldDealerListDropdown = false;
  dealerList = [];
  filteredDealerList = [];
  searchDealerTxt = '';
  selectedDealer = null;

  // filter - site
  isUnfoldSiteListDropdown = false;
  siteList = [];
  filteredSiteList = [];
  searchSiteTxt = '';
  selectedSite = null;

  // filter - user
  isUnfoldUserListDropdown = false;
  userList = [];
  filteredUserList = [];
  searchUserTxt = '';
  selectedUser = null;

  // filter - code
  isUnfoldCodeListDropdown = false;
  codeList = [];
  reseponseList = [];
  selectedCode = null;

  // Pager
  pager: any = {};
  curPage = 1;
  totalItem = 0;
  pageOffset = 20;
  pageOffsetStart = 1;
  pageOffsetEnd = 1;
  lastPage = 1;

  // Visibility Columns
  isShowColumnFilter = false;
  isVisibleColumns = {
    event_id: true,
    site_name: true,
    dealer_name: false,
    user_name: true,
    start_time: true,
    duration_time: true,
    code: true,
    response: true,
  }

  // Navigation subscription for cleanup
  private navigationSubscription: Subscription;

  constructor(
    public pagerService : PagerService,
    public commonService: CommonService,
    public c_components: c_components,
    public helper: Helper,
    private router: Router
  ) { super(); }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (this.actionMenus) {
      const actionMenus = this.actionMenus.toArray();
      actionMenus.forEach(actionMenu => {
        this.pagedItems.forEach(report=> {
          if (report.id + '' === actionMenu.nativeElement.id) {
            if (!actionMenu.nativeElement.contains(event.target)) {
              report.isShowMenu = false;
            }
          }
        })
      })
    }
    if (this.columnFilterbox) {
      const columnFilterbox = this.columnFilterbox.toArray()[0];
      if (columnFilterbox && !columnFilterbox.nativeElement.contains(event.target)) {
        this.isShowColumnFilter = false;
      }
    }
    if (this.siteSelect) {
      if (!this.siteSelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldSiteListDropdown = false;
        this.searchSiteTxt = '';
      }
    }
    if (this.dealerSelect) {
      if (!this.dealerSelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldDealerListDropdown = false;
        this.searchDealerTxt = '';
      }
    }
    if (this.userSelect) {
      if (!this.userSelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldUserListDropdown = false;
        this.searchUserTxt = '';
      }
    }
    if (this.codeSelect) {
      if (!this.codeSelect.nativeElement.contains(event.target)) {
        event.stopPropagation()
        this.isUnfoldCodeListDropdown = false;
      }
    }
  }

  async ngOnInit() {
    this.isLoading = true;

    // Try to restore filter state from sessionStorage
    const savedFilters = this.loadFilterState();

    if (savedFilters) {
      // Restore saved filters
      this.stime = savedFilters.stime;
      this.etime = savedFilters.etime;
      this.selectedDealer = savedFilters.selectedDealer;
      this.selectedSite = savedFilters.selectedSite;
      this.selectedUser = savedFilters.selectedUser;
      this.selectedCode = savedFilters.selectedCode;
      this.currentStime = null;
      this.currentEtime = null;
      // Reset search texts
      this.searchDealerTxt = '';
      this.searchSiteTxt = '';
      this.searchUserTxt = '';
    } else {
      // No saved filters - use defaults
      this.stime = null;
      this.etime = null;
      this.selectedDealer = null;
      this.selectedSite = null;
      this.selectedUser = null;
      this.selectedCode = null;
      this.currentStime = null;
      this.currentEtime = null;
      this.searchDealerTxt = '';
      this.searchSiteTxt = '';
      this.searchUserTxt = '';
    }

    await this.checkPermission()
    await this.getUeserList()
    await this.getSitePartners()
    await this.getSiteList()
    await this.getResolutionCodeList()
    await this.getMPSessionList();
    this.doFilter();
    this.isLoading = false;

    // Setup navigation listener to clear filters when leaving mp-sessions pages
    this.setupNavigationCleanup();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.navigationSubscription?.unsubscribe();
  }

  async checkPermission(){
    await this.helper.permission.load_my_permissions_only_if_not_loaded();
    this.hasReadSessionPermission = this.helper.permission.has("dealer_site_mp_session_read")
    this.hasReadSessionCodePermission = this.helper.permission.has("dealer_mp_session_response_read")
    this.hasCreatePublishedReportPermission = this.helper.permission.has('dealer_site_create_published_report')

    if(!this.hasReadSessionCodePermission) {
      this.tableHeader = [
        { name: 'Event ID', value: 'event_id', width: "8%" },
        { name: 'Site Name', value: 'site_name', width: "20%" },
        { name: 'Dealer Name', value: 'dealer_name', width: "15%" },
        { name: 'Operator', value: 'user_name', width: "10%" },
        { name: 'Start Time', value: 'start_time', width: "10%" },
        { name: 'Duration', value: 'duration_time', width: "14%" },
        { name: '  ', value: null, width: "5%" },
      ]
    }
  }

  get visibleTableHeader() {
    return this.tableHeader.filter(col => !col.value || this.isVisibleColumns[col.value]);
  }

  get filterableColumns() {
    return this.tableHeader.filter(col => col.value && col.value !== null);
  }

  async getSitePartners(){
    try {
      const res = await this.helper.dealer.get_site_partners();
      res.forEach(v => v.name = v?.internal_sub_dealer_id_with_company_name);
      this.dealerList = res;
      this.filteredDealerList = ims._.cloneDeep(this.dealerList);
    } catch (err) {
      console.debug('getSitePartners', err)
      this.isLoading = false;
    }
  }
  async getSiteList(){
    try{
      this.siteList = await this.helper.sites.get_sites();
      this.filteredSiteList = ims._.cloneDeep(this.siteList);
    } catch(err) {
      this.isLoading = false;
      console.debug('getSiteList:>', err)
    }
  }
  async getUeserList(){
    try {
      const members = await this.helper.dealer_member.get_members();
      const ipMembers = await this.helper.dealer_member.get_ip_members();
      this.parseUserList(members, ipMembers);
    } catch(err) {
      this.isLoading = false;
      console.debug('getUeserList:>', err)
    }
  }
  async getResolutionCodeList(){
    if(!this.hasReadSessionCodePermission) return;
    try {
      const res = await this.helper.mp_sessions.get_mp_sessions_resolution_code_list()
      this.parseCodeList(res)
    } catch(err) {
      this.isLoading = false;
      console.debug('getResolutionCodeList', err)
    }
  }
  async getMPSessionList(){
    try {
      if(!this.stime || !this.etime) {
        this.stime = ims.moment().startOf('day').unix();
        this.etime = ims.moment().endOf('day').unix();
      }
      if(this.stime === this.currentStime && this.etime === this.currentEtime) {
        console.log('list 1', this.stime)
        this.parseMpSessionList(this.originalSessionList)
        return;
      }
      console.log('list 2', this.stime)
      const list = await this.helper.mp_sessions.get_dealer_mp_sessions(this.stime, this.etime);
      this.parseMpSessionList(list)
    } catch(err) {
      this.isLoading = false;
      console.debug('getMPSessionList:>', err)
    }
  }

  parseUserList(members, ipMembersInfo){
    const ipMemberIds = members.filter(v => v.provider === 'ip').map(v => v.user_id)
    members.forEach(member => {
      member.name = `${member.firstname || ''} ${member.lastname || ''}` || 'No Name';
      if(ipMemberIds.includes(member.user_id)) {
        const ipMember = ipMembersInfo.find(v => v.id === member.provider_id)
        member.ip = ipMember.ip
      }
    })
    this.userList = members;
    this.filteredUserList = ims._.cloneDeep(this.userList);
  }

  parseCodeList(list){
    if(!list || !list.length) {
      this.codeList = []
      this.reseponseList = []
      return
    }

    for(let i = 0; i < list.length; i++) {
      const code = list[i]
      const responseList = code.responses
      const data = { code_id: code.id, code_name: code.description }
      this.codeList.push(data)

      for(let j = 0; j < responseList?.length; j++) {
        const response = responseList[j]
        response['code_id'] = code.id
        response['code_name'] = code.description
        this.reseponseList.push(response)
      }
    }
  }

  parseMpSessionList(list){
    this.currentStime = this.stime
    this.currentEtime = this.etime
    if(!list?.length)  {
      this.originalSessionList = ims._.cloneDeep([]);
      this.filteredSessionList = ims._.cloneDeep([]);
      return
    }
    list.forEach(session => {
      const { code_id, code_name, response } = this.parseCodeId(session)

      session['isShowMenu'] = false;
      session['dealer_name'] = this.dealerList.find(v => v.dealer_id === session.site_dealer_id)?.name || 'No Dealer Name';
      session['user_name'] = this.parseUserName(session.user_id)
      session['code_id'] = code_id
      session['code_name'] = code_name
      session['response'] = response
      session['notes'] = this.parseNote(session)
      session['duration'] = this.parseDurationTimeLabel(session)
      session['duration_time'] = this.parseDurationTime(session)
    })

    this.originalSessionList = ims._.cloneDeep(list);
    this.filteredSessionList = ims._.cloneDeep(list);
  }

  parseUserName(userId){
    if(!this.userList || !this.userList?.length) return 'No Name';
    const user = this.userList.find(v => v.user_id === userId)
    return this.capitalizeFirstLetter(user?.name) || 'No Name'
  }
  capitalizeFirstLetter(string: string): string {
    if(!string || typeof string != 'string') return ''
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  parseNote(session) {
    try {
      if(!session?.notes) return '';
      if(typeof session?.notes != 'string') return session?.notes
      return JSON.parse(session.notes)
    } catch (err) {
      console.debug('parseNote', session.id, session?.notes)
      return ''
    }
  }
  parseCodeId(session){
    if(!this.reseponseList || !this.reseponseList?.length) return { code_id : null, code_name: null };

    const code = this.reseponseList.find(v => v?.response_id === session?.mp_session_response_id)
    if(code) return { code_id: code?.code_id || null , code_name: code?.code_name || null, response: code?.name || null }
    return { code_id : null, code_name: null, response: null }
  }
  parseDurationTimeLabel(session){
    if(!session?.start_time || !session?.end_time) return null;
    const startTime = ims.moment(session.start_time)
    const endTime = ims.moment(session.end_time)

    const hour = ims.moment.duration(endTime.diff(startTime)).hours()
    const min = ims.moment.duration(endTime.diff(startTime)).minutes()
    const sec = ims.moment.duration(endTime.diff(startTime)).seconds()

    let result = ''
    if(hour) result += `${hour} hour `
    if(min) result += `${min} min `
    if(sec) result += `${sec} sec `

    return `${result} on screen`;
  }
  parseDurationTime(session){
    if(!session?.start_time || !session?.end_time) return null;
    const startTime = ims.moment(session.start_time)
    const endTime = ims.moment(session.end_time)
    return endTime.diff(startTime);
  }

  // --------------------------------------------------------------------------------
  // FILTER
  // CASE 1) Date Range
  async dateRange(event){
    // event = { label: string, selected: { start: Moment, end: Moment} }
    if(!event) return
    const { selected } = event
    const { start, end } = selected
    
    const partedStart = start?.unix()
    const partedEnd = end?.unix()
    console.log('Date Range Filter Changed:', start?.format(), partedStart, partedEnd);
    if(this.stime === partedStart && this.etime === partedEnd) return

    this.stime = partedStart
    this.etime = partedEnd

    this.saveFilterState();
    await this.refresh()
  }

  async refresh(){
    this.isLoading = true;
    await ims.tool.sleep(100)
    await this.getMPSessionList();
    this.setPage(1);
    this.isLoading = false;
  }

  // CASE 2) DEALER
  selectDealer(dealer){
    this.selectedDealer = dealer
    this.isUnfoldDealerListDropdown = false
    this.searchDealerTxt = ''

    this.saveFilterState();
    this.doFilter()
  }
  searchDealer(searchDealerTxt) {
    this.filteredDealerList = this.dealerList.filter(dealer => dealer.name.toLowerCase().indexOf(searchDealerTxt.toLowerCase()) > -1);
  }

  clearDealerFilter(){
    this.searchDealerTxt = ''
    this.selectedDealer = null
    this.filteredDealerList = this.dealerList

    this.saveFilterState();

    this.doFilter()
  }


  // CASE 3) SITE
  selectSite(site){
    this.selectedSite = site
    this.isUnfoldSiteListDropdown = false
    this.searchSiteTxt = ''

    this.saveFilterState();
    this.doFilter()
  }
  searchSite(searchSiteTxt) {
    this.filteredSiteList = this.siteList.filter(site => site.name.toLowerCase().indexOf(searchSiteTxt.toLowerCase()) > -1);
  }

  clearSiteFilter(){
    this.searchUserTxt = ''
    this.selectedSite = null
    this.filteredSiteList = this.siteList

    this.saveFilterState();
    this.doFilter()
  }

  // CASE 4) USER
  selectUser(user){
    this.selectedUser = user
    this.isUnfoldUserListDropdown = false
    this.searchUserTxt = ''

    this.saveFilterState();
    this.doFilter()
  }
  searchUser(searchUserTxt) {
    this.filteredUserList = this.userList.filter(user => {
      if(user?.name?.toLowerCase().indexOf(searchUserTxt.toLowerCase()) > -1) return true;
      if(user?.email?.toLowerCase().indexOf(searchUserTxt.toLowerCase()) > -1) return true;
      return false;
    });
  }

  clearUserFilter(){
    this.searchUserTxt = ''
    this.selectedUser = null
    this.filteredUserList = this.userList

    this.saveFilterState();
    this.doFilter()
  }

  // CASE 5) code
  selectCode(code){
    this.selectedCode = code
    this.isUnfoldCodeListDropdown = false

    this.saveFilterState();
    this.doFilter()
  }

  clearCodeFilter(){
    this.selectedCode = null

    this.saveFilterState();
    this.doFilter()
  }

  // Let's do filtering
  doFilter(){
    if(!this.originalSessionList?.length) {
      this.filteredSessionList = [];
      this.setPage(1);
      return;
    }

    const target = ims._.cloneDeep(this.originalSessionList)
    this.filteredSessionList = target.filter(item => {
      const dealerMatch = !this.selectedDealer || this.selectedDealer.dealer_id === item.site_dealer_id
      const siteMatch = !this.selectedSite || this.selectedSite.site_id === item.site_id
      const userMatch = !this.selectedUser || this.selectedUser.user_id === item.user_id
      const codeMatch = !this.selectedCode || this.selectedCode.code_id === item.code_id

      return dealerMatch && siteMatch && userMatch && codeMatch;
    });

    this.setPage(1);
  }


  // --------------------------------------------------------------------------------
  setMorePosition(report){
    const docElem = document.documentElement
    let elem = document.getElementById(report?.id);
    let more = document.getElementById('more-'+report?.id);
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right - 15
    const posY = rect.top - 30;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }
  setTooltipPosition(e) {
    e.stopPropagation();
    const docElem = document.documentElement
    let elem = e.currentTarget;
    let more = elem.querySelector('.--g-tooltip');
    let rect = elem.getBoundingClientRect();
    const posX = docElem.clientWidth - rect.right - 120
    const posY = rect.top - 30;
    more.style.right = posX + 'px';
    more.style.top = posY + 'px';
  }

  toggleMenu(report){
    const targetMenu = report.isShowMenu;
    report.isShowMenu = !targetMenu;
  }

  // STYLES
  determineElementToShow(){
    if(this.isLoading) return false;
    if(!this.hasReadSessionPermission) return 'no-permission'
    if(!this.pagedItems?.length) return 'no-data'
    return 'normal'
  }

  // -----------------------------------------------------------------------------
  // ACTION
  goToDetail(event, session){
    event.stopPropagation();
    this.helper.router.navigate_to(`/reports/mp-sessions/${session.id}/detail`)
  }
  async goToCreateReportPage(event, session){
    event.stopPropagation();
    const isStandard = await this.isDisabledCreateReport(session)
    if(isStandard) {
      return this.c_components.dialog.open('warning', {
        header: 'Create Report is not available for Basic Dealer Plan',
        contents: 'Please upgrade your plan to access this feature.',
        submit_btn: "OK",
        submit_class: ["button-primary"],
        isConfirm: true,
        icon: 'warning',
        color: 'orange',
        submit_func: () => {},
      });
    }

    this.helper.mp_sessions.setSelectedSessions([session])
    this.helper.router.navigate_to(`/reports/mp-sessions/${session.id}/create-report`)
  }
  goToSite(event, session){
    event.stopPropagation();
    this.helper.router.navigate_to('/customers/report/session', { id: session.site_id})
  }
  async isDisabledCreateReport(session){
    const dealerType = this.dealerList.find(v => v.dealer_id === session.site_dealer_id)?.dealer_type;
    await this.helper.dealer_plan.load_dealer_plan_for_site({ dealer_id: session.site_dealer_id, dealer_type: dealerType === 2 ? null : 'partner' })
    return this.helper.dealer_plan.site_dealer_plan() === 1;
  }

  // -----------------------------------------------------------------------------
  compare(a: number | string | null, b: number | string | null, isAsc: boolean) {
    if (a === null && b === null) return 0;
    if (a === null) return isAsc ? -1 : 1;
    if (b === null) return isAsc ? 1 : -1;

    if (typeof a === 'string') a = a.toLocaleLowerCase();
    if (typeof b === 'string') b = b.toLocaleLowerCase();

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  sortTableByColumn(sortTarget) {
    if (!sortTarget.sortColumn || sortTarget.sortDirection === '') {
      return;
    }
    let data = this.filteredSessionList;

    const tmpData = data.sort((a, b) => {
      const isAsc = sortTarget.sortDirection === 'asc';
      switch (sortTarget.sortColumn) {
        case 'site_name': return this.compare(a?.site_name, b?.site_name, isAsc);
        case 'dealer_name': return this.compare(a?.dealer_name, b?.dealer_name, isAsc);
        case 'user_name': return this.compare(a?.user_name, b?.user_name, isAsc);
        case 'start_time': return this.compare(a?.start_time, b?.start_time, isAsc);
        case 'duration_time': return this.compare(a?.duration_time, b?.duration_time, isAsc);
        case 'code': return this.compare(a?.code_name, b?.code_name, isAsc)
        case 'event_id': return this.compare(a?.event_id, b?.event_id, isAsc);
        default: return 0;
      }
    });

    this.pagedItems = tmpData;
    this.setPage(1)
  }

  setPage(page: number) {
    this.pagedItems = []

    const target = this.filteredSessionList
    if(!target){
      console.debug('⚠️ list is lost', target)
      return this.isLoading = false
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(target?.length, page, this.pageOffset);
    this.totalItem = target?.length;
    // get current page of items
    this.pagedItems = target.slice(this.pager.startIndex, this.pager.endIndex + 1);
    this.curPage = this.pager.currentPage;
    if (this.curPage -1 < 0) {
      this.pageOffsetStart = 0;
    } else if (this.curPage -1 == 0) {
      this.pageOffsetStart = 1;
    } else {
      this.pageOffsetStart =  (this.curPage -1) * this.pageOffset +1;
    }

    if (this.curPage * this.pageOffset > this.totalItem) {
      this.pageOffsetEnd =  this.totalItem;
    } else {
      this.pageOffsetEnd =  this.curPage * this.pageOffset;
    }
    this.isLoading = false;
  }

  // -----------------------------------------------------------------------------
  // Filter State Persistence Methods

  // Load filter state from sessionStorage
  private loadFilterState(): MpSessionsManagerFilterState | null {
    const saved = ims.tool.session_storage.get<MpSessionsManagerFilterState>(MP_SESSIONS_MANAGER_FILTERS_KEY);
    return saved;
  }

  // Save current filter state to sessionStorage
  private saveFilterState(): void {
    const state: MpSessionsManagerFilterState = {
      stime: this.stime,
      etime: this.etime,
      selectedDealer: this.selectedDealer ? {
        dealer_id: this.selectedDealer.dealer_id,
        name: this.selectedDealer.name
      } : null,
      selectedSite: this.selectedSite ? {
        site_id: this.selectedSite.site_id,
        name: this.selectedSite.name
      } : null,
      selectedUser: this.selectedUser ? {
        user_id: this.selectedUser.user_id,
        name: this.selectedUser.name,
        email: this.selectedUser.email,
        ip: this.selectedUser.ip
      } : null,
      selectedCode: this.selectedCode ? {
        code_id: this.selectedCode.code_id,
        code_name: this.selectedCode.code_name
      } : null
    };

    ims.tool.session_storage.set(MP_SESSIONS_MANAGER_FILTERS_KEY, state);
  }

  // Clear filter state from sessionStorage
  private clearFilterState(): void {
    ims.tool.session_storage.remove(MP_SESSIONS_MANAGER_FILTERS_KEY);
  }

  // Setup navigation listener to clear filters when leaving mp-sessions pages
  private setupNavigationCleanup(): void {
    this.navigationSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Check if navigating away from mp-sessions pages
        const isLeavingMpSessionsPages = !event.url.includes('/reports/mp-sessions');

        if (isLeavingMpSessionsPages) {
          this.clearFilterState();
        }
      }
    });
  }

  toggleShowColumnFilter() {
    this.isShowColumnFilter = !this.isShowColumnFilter;
  }

  toggleColumnVisibility(column) {
    if (column.value) {
      this.isVisibleColumns[column.value] = !this.isVisibleColumns[column.value];
    }
  }
}
